export const formatDecimal = (number: number) => {
  return number.toLocaleString("tr-TR", {
    style: "decimal",
    minimumFractionDigits: 2,
  });
};

export const formatDateString = (dateString: string) => {
  var date = new Date(dateString);

  var year = date.getFullYear();
  var month = (date.getMonth() + 1).toString().padStart(2, "0");
  var day = date.getDate().toString().padStart(2, "0");

  var hours = date.getHours().toString().padStart(2, "0");
  var minutes = date.getMinutes().toString().padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}`;
};
